import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 1rem 70px 1rem;
    width: calc(100% - 140px);
    margin: 0 auto;
    isolation: isolate;
    background-color: var(--n-bg-1);
    .box {
        position: relative;
        padding: 3rem ;
        overflow: hidden;
        border-radius: 8px;
        isolation: isolate;
        display: flex;
        border: 1px solid #D9D9D9;
        .bgimage {
            z-index: 1;
            position: absolute;
            inset: 0 0 0 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
        .cover {
            z-index: 2;
            position: absolute;
            inset: 0;
            background-color: #00000088;
        }
        .main-data {
            position: relative;
            z-index: 3;
            width: calc(50% - 0px);
            padding: 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &.big {
                width: calc(100%);
            }
            .title {
                font-size: 2rem;
                font-weight: 800;
                color: #fff;
            }
            .items {
                margin: 1rem 0;
                font-size: 1rem;
                color: #fff;
                --color: #fff;
                /* --color: var(--fsc-d-1); */
                text-align: start;
                .item {
                    display: flex;
                    margin: 1rem 0;
                    gap: 8px;
                }
            }
        }
        .otherside {
            z-index: 4;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            margin: 1rem 0;
            .cta {
                cursor: pointer;
                border: 1px solid var(--fsc-d-1);
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: 600;
                text-align: center;
                padding: 0.55rem 1rem 0.75rem;
                color: #fff;
                /* color: var(--fsc-d-1); */
                text-decoration: none;
                white-space: nowrap;
                width: min-content;
                display: flex;
                gap: 12px;
                justify-content: center;
                &.cta-btn-1 {
                    border-radius: 8px;
                    border: 1px solid var(--prime-2);
                    :hover {
                        background-color: #00000020;
                    }
                }
                &.cta-btn-2 {
                    background-color: #fff;
                    color: var(--fsc-d-1);
                    :hover {
                        background-color: #e5e5e5;
                    }
                }
            }
        }
    }
    
    @media (max-width: 850px){
        width: calc(100% - 32px);
        padding: 1rem 16px 1rem;
        .box {
            padding: 3rem 1rem 1rem;
            flex-direction: column;
            .main-data {
                width: 100%;
            }
            .otherside {
                margin: 1rem 0 0;
                .cta { 
                    width: calc(100% - 2rem);
                }
            }
            
        }
    }
`;

export default function BoxHeadlineDetail4({language,data}) {
    const makeDetails = (dir) => {
        return data.data.details.map((val) => {
            return (
                <div className="item">
                    <div className="text">{val}</div>
                </div>
            )
        })
    }
    let lan = language.filename;
    let dir = language.dir;
    return (
      <Style>
        <div className="box">
            <div className="bgimage"><img src={data.data.bgimage} alt={data.data.title}/></div>
            <div className="cover"></div>
            <div className={"main-data" + ((!data.data.link) ? " big" : "")}>
                <div className="title">{data.data.title}</div>
                <div className="items">
                    {makeDetails(dir)}
                </div>
            </div>
            <div className="otherside">
                {(data.data.link && data.data.link.type === "link") ? (
                    <Link to={"/" + lan + data.data.link.route} className="cta cta-btn-1">
                        {data.data.link.title} 
                    </Link>
                ): ''}
                {(data.data.link && data.data.link.type === "link-out") ? (
                    <a href={data.data.link.route} className="cta cta-btn-1" target="_blank">
                        {data.data.link.title} 
                    </a>
                ): ''}
            </div>
        </div>
      </Style>
  );
}
